<template>
  <div class="company-details">
    <div class="settings-top-bar sticky-header" ref="optionsTopBar">
      <div class="text-right">
        <p class="">
          <button class="btn btn-info btn-icon mar-rt-10"
            @click.prevent="addLocation"
            :title="$t('general.add') + ' ' + $t('settingCompany.location')"><i class="ti-plus"></i>
          </button>
          <a class="btn btn-success btn-icon mar-rt-10"  @click.prevent="validate" :title="$t('general.save') + ' ' + $t('settingCompany.location')">
            <i class="ti-save"></i>
          </a>
        </p>
      </div>
    </div>
    <div :class="(loading ? 'show-loader' : 'hide-loader')">
      <div class="el-loading-spinner">
        <svg viewBox="25 25 50 50" class="circular">
          <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
        </svg><!---->
      </div>
    </div>
    <div ref="compDetailsContainer" class="company-wrap" :style="{height: windowHeight - pageTopHeight - navbarHeaderHeight - 1 + 'px'}">
      <template v-for="(location, index) in model.locations_details">
      <div class="card location-card">
        <div class="card-content">
          <form class="clearfix row">
              <div class="col-md-12">
                <h5 class="company-location">
                  <i class="ti-home"></i> {{$t('settingCompany.bussLoc')}}: {{location.name}}
                  <button class="btn btn-danger pull-right btn-icon mar-to--5"
                          v-if="showDelete || model.isNew"
                          @click.prevent="deleteLocation(location.id)" :title="$t('general.delete')"><i class="ti-trash"></i></button>

                </h5>
                <div class="form-group">
                  <h6>{{ $t('upload.uploadLabel') }}</h6>
                  <hr class="sm">
                  <div class="row">
                    <div class="col-md-6">
                      <!-- <label class="pad-bt-5">{{$t('upload.uploadLabel')}}</label> -->
                      <label for="download" class="pad-bt-5">{{ $t('upload.downloadImportProductsTemplate') }}</label>
                      <br>
                      <a name="download" :href="apiUrl + 'download-import-form?token=' + $session.get('token')" target="_blank">
                        <el-button size="small" type="primary" @click="downloadForm()">{{ $t('upload.downloadButton') }}</el-button>
                      </a>
                    </div>
                    <div class="col-md-6">
                      <div class="row">
                        <div class="col-md-6">
                          <archive-input
                            :location="location"
                          ></archive-input>
                        </div>
                        <div class="col-md-6">
                          <import-products-input
                            :location="location"
                          ></import-products-input>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <hr/> -->
              </div>
              <div v-if="location.is_magister_location" class="col-md-12">
                <div class="form-group">
                  <h6>{{ $t('magister.syncLabel') }}</h6>
                  <hr class="sm">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="row">
                        <div class="col-md-6">
                          <label for="download" class="pad-bt-5">{{ $t('magister.syncPrices') }}</label>
                          <br>
                          <el-button size="small" type="primary" @click.prevent="updateProductPricesMagister(location)">{{ $t('general.start') }}</el-button>
                        </div>
                        <div class="col-md-6">
                          <label for="download" class="pad-bt-5">{{ $t('magister.syncStocks') }}</label>
                          <br>
                          <el-button size="small" type="primary" @click.prevent="updateProductStocksMagister(location)">{{ $t('general.start') }}</el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="location.is_tazz_location" class="col-md-12">
                <div class="form-group">
                  <h6>{{ $t('tazz.syncLabel') }}</h6>
                  <hr class="sm">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="row">
                        <div class="col-md-6">
                          <el-button size="small" type="primary" @click.prevent="updateTazzMenu(location)">{{ $t('general.start') }}</el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="location.is_rkeeper_location" class="col-md-12">
                <div class="form-group">
                  <h6>{{ $t('rkeeper.sync') }}</h6>
                  <hr class="sm">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="row">
                        <div class="col-md-6">
                          <el-button size="small" type="primary" @click.prevent="importCategories(location)">{{ $t('rkeeper.categories') }}</el-button>
                          <el-button size="small" type="primary" @click.prevent="importProducts(location)">{{ $t('rkeeper.products') }}</el-button>
                        </div>
                        <div class="col-md-6">
                          <el-button size="small" type="primary" @click.prevent="syncProductPrices(location)">{{ $t('rkeeper.productPrices') }}</el-button>
                          <el-button size="small" type="primary" @click.prevent="syncOptionPrices(location)">{{ $t('rkeeper.optionPrices') }}</el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="location.glovo_company_id" class="col-md-12">
                <div class="form-group">
                  <h6>{{ $t('glovo.syncLabel') }}</h6>
                  <hr class="sm">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="row">
                        <div class="col-md-6">
                          <el-button size="small" type="primary" @click.prevent="syncGlovoMenu(location)">{{ $t('general.start') }}</el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="location.freya_cloud_id" class="col-md-12">
                <div class="form-group">
                  <h6>{{ $t('epRestaurant.importLabel') }}</h6>
                  <hr class="sm">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="row">
                        <div class="col-md-6">
                          <el-button size="small" type="primary" @click.prevent="syncFreyaCloudMenu(location)">{{ $t('general.start') }}</el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="location.ep_restaurant_id" class="col-md-12">
                <div class="form-group">
                  <h6>{{ $t('epRestaurant.importLabel') }}</h6>
                  <hr class="sm">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="row">
                        <div class="col-md-6">
                          <el-button size="small" type="primary" @click.prevent="syncEpRestaurantMenu(location)">
                            {{ $t('epRestaurant.importButton') }}
                          </el-button>
                          <el-button size="small" type="primary" @click.prevent="syncEpRestaurantMenu(location, true)">
                            {{ $t('epRestaurant.syncButton') }}
                          </el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <hr/>
              </div>

              <div class="col-md-12" v-if="showDelete">
                {{$t('settingCompany.copyProductsFrom')}}
                <select class="select-primary form-control inline-auto mar-lt-5"
                        :ref="'copyFrom' + location.id">
                  <template v-for="l in model.locations_details">
                    <option v-if="l.id !== location.id"
                            class="select-primary"
                            :value="l.id">{{l.name}}
                    </option>
                  </template>
                </select>
                <button class="btn btn-info btn-icon duplicate-prod mar-to--5 mar-lt-5"
                  @click.prevent="copyProducts(location.id)"><i class="fa fa-copy"></i>
                </button>
                <br>
                <br>
                <button class="btn btn-danger btn-icon delete-prod mar-to--5 mar-lt-5"
                  @click.prevent="deleteProducts(location.id)">
                  Sterge toate produsele din aceasta locatie
                </button>
                <hr>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{$t('settingCompany.name')}}</label>
                  <input type="text" name="phome" :placeholder="$t('settingCompany.name')" v-model="location.name" v-validate="modelValidate.name" class="form-control">
                </div>
              </div>
              <br style="clear:both;" />
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{$t('settingCompany.phone')}}</label>
                  <input type="text" name="phome" :placeholder="$t('settingCompany.phone')" v-model="location.phone" v-validate="modelValidate.phone" class="form-control">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{$t('settingCompany.email')}}</label>
                  <input type="text" name="email" :placeholder="$t('settingCompany.email')" v-model="location.email" v-validate="modelValidate.email" class="form-control">
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="control-label">{{$t('settingCompany.street')}}</label>
                  <input type="text" v-model="location.street" name="street" :placeholder="$t('settingCompany.street')" class="form-control" v-validate="modelValidate.street">
                </div>
              </div>
               <div class="col-md-2">
                <div class="form-group">
                  <label class="control-label">{{$t('settingCompany.number')}}</label>
                  <input type="text" v-model="location.number" name="street" v-validate="modelValidate.number" :placeholder="$t('settingCompany.number')" class="form-control" >
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="control-label">{{$t('settingCompany.city')}}</label>
                  <input type="text" v-model="location.city" name="city" :placeholder="$t('settingCompany.city')" class="form-control" v-validate="modelValidate.city">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="control-label">{{$t('settingCompany.country')}}</label>
                  <select v-model="location.country"
                          name="country"
                          class="select-primary form-control"
                          ref="country"
                          v-validate="modelValidate.country"
                          @change="updateCountry(location)">
                    <option v-for="country in countriesList"
                            class="select-primary"
                            :value="country.alpha2">{{country.name}}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="control-label">{{$t('settingCompany.state')}}</label>
                  <template v-if="showStateDrop(location)">
                    <select v-model="location.state_id"
                            class="select-primary form-control">
                      <option v-for="state in getStatesOptions(location)"
                            class="select-primary"
                            :value="state.id">{{state.name}}
                      </option>
                    </select>
                  </template>
                  <template v-else>
                    <input type="text" v-model="location.state" name="state"  class="form-control" v-validate="modelValidate.state">
                  </template>
                </div>
              </div>
              <div class="col-md-6" v-if="paymentGroups">
                <div class="form-group">
                  <h6>{{$t('settingCompany.cardPaymentDetails')}}</h6>
                  <hr class="sm">
                  <div class="row">
                    <div class="col-md-6">
                      <label class="control-label">{{$t('settingCompany.paylikeKeys')}}</label>
                      <select v-model="location.payment_group"
                              class="select-primary form-control"
                              v-validate="{required:true}">
                        <option v-for="(pId, pVal) in paymentGroups"
                              class="select-primary"
                              :value="pVal">{{pId}}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="row">
                    <div class="col-md-6">
                      <label class="control-label">{{$t('settingCompany.posDiscount')}}</label>
                      <input type="text" v-model="location.id_discount_pos" name="posDiscount" class="form-control">
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <h6>{{$t('settingCompany.printSettings')}}</h6>
                  <hr class="sm">
                  <div class="row">
                    <div class="col-md-12">
                       <p-checkbox
                        v-model="location.auto_print"
                      >{{$t('settingCompany.automatPrintOrder')}}</p-checkbox>
                    </div>
                  </div>
                  <div class="row mar-bt-10" style="">
                    <div class="col-md-12">
                       <p-checkbox
                        v-model="location.auto_print_local_server"
                      >{{$t('settingCompany.autoPrintLocalServer')}}</p-checkbox>
                    </div>
                  </div>
                  <div class="row mar-bt-10" style="">
                    <div class="col-md-12">
                       <p-checkbox
                        v-model="location.use_printer"

                      >{{$t('settingCompany.autoSendOrderToPrinter')}}</p-checkbox>
                    </div>
                  </div>
                  <div class="row" v-if="location.use_printer" style="">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="control-label">{{$t('settingCompany.printerIp')}}</label>
                        <input type="text"
                                v-model="location.printer_ip"
                                name="printer_ip"
                                :placeholder="$t('settingCompany.printerIp')"
                                class="form-control" >
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="control-label">{{$t('settingCompany.printerPort')}}</label>
                        <input type="text"
                                v-model="location.printer_port"
                                name="printer_port"
                                :placeholder="$t('settingCompany.printerPort')"
                                class="form-control" >
                      </div>
                    </div>
                  </div>

                </div>
              </div>
              <div class="col-md-6">
                <br/>
                <div class="form-group">
                  <label class="control-label">{{$t('settingCompany.transport_setings')}}</label>
                  <hr class="sm">
                  <div class="row">
                    <div class="col-md-12">
                      <p-checkbox
                      v-model="location.email_transport"
                      >{{$t('settingCompany.email_transport')}}</p-checkbox>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <p-checkbox
                        v-model="location.use_twilio"
                      >{{$t('settingCompany.twilio_call')}}</p-checkbox>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <h6>{{$t('settingCompany.invoicePerOrder')}}</h6>
                  <hr class="sm">
                  <div class="col-md-12">
                    <p-checkbox
                    v-model="location.smartbill_status"
                    >{{$t('settingLocationGroups.active')}}</p-checkbox>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="control-label">{{$t('settingCompany.apiKey')}}</label>
                      <input
                        v-validate="{required: location.smartbill_status}"
                        :disabled="!location.smartbill_status"
                        type="text"
                        v-model="location.smartbill_api_key"
                        name="street"
                        :placeholder="$t('settingCompany.apiKey')"
                        class="form-control">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="control-label">{{$t('settingCompany.cif')}}</label>
                      <input
                        :disabled="!location.smartbill_status"
                        type="text"
                        v-model="location.smartbill_cif"
                        name="street"
                        :placeholder="$t('settingCompany.cif')"
                        class="form-control"
                        v-validate="{required: location.smartbill_status}">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="control-label">{{$t('settingCompany.email')}}</label>
                      <input
                        v-validate="{required: location.smartbill_status}"
                        :disabled="!location.smartbill_status"
                        type="text"
                        v-model="location.smartbill_email"
                        name="street"
                        :placeholder="$t('marketingPromos.email')"
                        class="form-control">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="control-label">{{$t('settingCompany.series')}}</label>
                      <input
                        :disabled="!location.smartbill_status"
                        type="text"
                        v-model="location.smartbill_series"
                        name="street"
                        :placeholder="$t('settingCompany.series')"
                        class="form-control"
                        v-validate="{required: location.smartbill_status}">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <p-checkbox
                      v-model="location.smartbill_send_auto"
                      :disabled="!location.smartbill_status"
                    >{{$t('settingCompany.automatedInvoice')}}</p-checkbox>
                    <p-checkbox
                      v-model="location.smartbill_add_to_cc"
                      :disabled="!location.smartbill_status"
                    >{{$t('settingCompany.addToCC')}}</p-checkbox>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <h6>{{$t('vat.generalTaxes')}}</h6>
                  <hr class="sm">
                  <table class="table mar-bt-0">
                    <thead>
                        <tr>
                          <th>{{$t('settingTaxes.single')}}</th>
                          <th>{{$t('settingTaxes.type')}}</th>
                          <th>{{$t('settingTaxes.amount')}}</th>
                          <th style="padding-left: 55px">{{$t('catalogProdOpt.posid')}}</th>
                          <th></th>
                        </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(tax_rate, taxIndex) in location.taxes">
                        <td>
                          <select
                            @input="updateVatPrinterId($event, index, taxIndex)"
                            v-model="tax_rate.id"
                            class="form-control"
                            v-validate="{required: true}" >
                            <option v-for="tax in taxes"
                                    :value="tax.id"
                                    :data-name="tax.name"
                                    :disabled="disableTaxOption(location.id, tax.id) && tax.id != tax_rate.id"
                                    >{{tax.name}}</option>
                          </select>
                            <!--   <input type="text"
                                    min="0"
                                    class="form-control"
                                    :name="'name'+tax_rate.id"
                                    v-validate="{required: true}"
                                    v-model="tax_rate.name">  -->
                            <small class="text-danger" v-if="errors.has(tax_rate.hash_id)">
                              {{ getError(tax_rate.hash_id) }}
                            </small>
                        </td>
                        <td>
                            <select :name="'type'+tax_rate.id" v-model="tax_rate.type" class="form-control" v-validate="{required: true}" >
                              <!-- <option value="FIXED_INCLUDED">{{$t('taxTypes.FIXED_INCLUDED')}}</option> -->
                              <option value="FIXED_EXCLUDED">{{$t('taxTypes.FIXED_EXCLUDED')}}</option>
                              <!-- <option value="PERCENTAGE_INCLUDED">{{$t('taxTypes.PERCENTAGE_INCLUDED')}}</option> -->
                              <option value="PERCENTAGE_EXCLUDED">{{$t('taxTypes.PERCENTAGE_EXCLUDED')}}</option>
                            </select>
                        </td>
                        <td>
                            <label class="label-currency">{{tax_rate.type == 'FIXED_EXCLUDED' ? currency : '%'}}</label>

                            <input type="number" min="0" class="form-control field-currency" :name="'amount'+tax_rate.id" v-model="tax_rate.amount" v-validate="{required: true, min_value:0}" >
                        </td>
                        <td>
                            <input type="number" min="0" class="form-control field-currency" :name="'pos_id'+tax_rate.pos_id" v-model="tax_rate.pos_id" >
                        </td>
                        <td>
                            <button class="btn btn-danger btn-icon pull-right" @click.prevent="deleteTax(location.id, tax_rate.id)"><i title="Remove" class="ti-trash "></i></button>
                        </td>
                      </tr>
                      <tr v-if="location.taxes.length < taxes.length">
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                  <button
                    class="btn btn-icon btn-info "
                    v-if="location.taxes.length < taxes.length"
                    @click.prevent="addNewTax(location.id)"
                    :title="$t('general.add') + ' ' + $t('settingTaxes.single')">
                    <i class="ti-plus"></i>
                  </button>
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <h6>{{$t('catalogCateg.vat')}} <small>({{$t('catalogCateg.included')}})</small></h6>
                  <hr class="sm">
                  <table class="table mar-bt-0">
                    <thead>
                        <tr>
                          <th width="25%">{{$t('catalogCateg.vat')}}</th>
                          <th width="25%">{{$t('settingTaxes.type')}}</th>
                          <th width="20%">{{$t('settingTaxes.amount')}}</th>
                          <th width="20%" style="padding-left: 55px">Printer ID</th>
                          <th></th>
                        </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(tax_rate, vatIndex) in model.locations_details[index].vat">
                        <!-- <input type="hidden" :name="'tax_rate'+tax_rate.id" v-model="tax_rate.id"> -->
                        <td>
                          <select v-model="tax_rate.tax_id"
                                  class="form-control"
                                  v-validate="{required: true}" >
                            <option v-for="tax in vat"
                                    :value="tax.id"
                                    :disabled="disableVatOption(index, tax.id) && tax.id != tax_rate.tax_id"
                                    >{{tax.name}}</option>
                          </select>
                            <small class="text-danger" v-if="errors.has(tax_rate.hash_id)">
                              {{ getError(tax_rate.hash_id) }}
                            </small>
                        </td>
                        <td>
                            <select disabled :name="'type'+tax_rate.id" class="form-control" v-validate="{required: true}" >
                              <!-- <option value="FIXED_INCLUDED">{{$t('taxTypes.FIXED_INCLUDED')}}</option> -->
                              <!-- <option value="FIXED_EXCLUDED">{{$t('taxTypes.FIXED_EXCLUDED')}}</option> -->
                              <!-- <option value="PERCENTAGE_INCLUDED">{{$t('taxTypes.PERCENTAGE_INCLUDED')}}</option> -->
                              <option selected="true" value="PERCENTAGE_EXCLUDED">{{$t('taxTypes.PERCENTAGE_EXCLUDED')}}</option>
                            </select>
                        </td>
                        <td>
                            <label class="label-currency">{{tax_rate.type == 'FIXED_EXCLUDED' ? currency : '%'}}</label>

                            <input type="number" min="0" class="form-control field-currency" :name="'amount'+tax_rate.id" v-model="tax_rate.amount" v-validate="{required: true, min_value:0}" >
                        </td>
                        <td>
                            <!-- <label class="label-currency">{{tax_rate.type == 'FIXED_EXCLUDED' ? currency : '%'}}</label> -->
                            <!-- <label class="label-currency">Printer ID</label> -->

                            <input type="text" placeholder="A" class="form-control field-currency" :name="'amount'+tax_rate.id" v-model="tax_rate.printer_id" v-validate="{required: true}" >
                        </td>
                        <td>
                            <button class="btn btn-danger btn-icon pull-right" @click.prevent="deleteVat(index, tax_rate.id, vatIndex)"><i title="Remove" class="ti-trash "></i></button>
                        </td>
                      </tr>
                      <tr v-if="!location.vat || location.vat.length < vat.length">
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                  <button
                    class="btn btn-icon btn-info "
                    v-if="!location.vat || location.vat.length < vat.length"
                    @click.prevent="addNewVat(index, location.token)"
                    :title="$t('general.add') + ' ' + $t('settingTaxes.single')">
                    <i class="ti-plus"></i>
                  </button>
                </div>
                <div class="text-center">
                  <span class="help-block warning mb-0"><i class="fa fa-info-circle" aria-hidden="true"></i>{{$t('settingTaxes.notice3')}} <a href="#" @click.prevent="goToCompany()">{{$t('settingTaxes.notice4')}}</a>.</span>
                </div>
              </div>

              <template>
                <div class="col-md-12">
                  <h6>{{$t('settingCompany.locationImage')}}</h6>
                  <hr class="sm">
                  <div class="col-md-12">
                    <image-input
                      :location="location"
                      :label="$t('settingCompany.locationImage')"
                      :image="location.image"
                      imageField="image"
                    />
                  </div>
                </div>
              </template>

              <template>
                <div class="col-md-12">
                  <hr>
                  <div class="form-group">
                    <h5 class="col-md-1 pad-rg-0">{{ $t('catalogProdOpt.menuQr') }}</h5>
                    <div class="col-md-2">
                      <select v-model="location.use_dynamic_menu"
                            class="form-control"
                            @input="handleMenu(index, $event)">
                        <option v-for="menu in menuType"
                                :value="menu.id"
                                >{{menu.label}}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <hr>
                </div>
                <div v-if="!location.use_dynamic_menu" class="col-md-6">
                  <file-input
                    :location="location"
                  />
                </div>
                <div v-if="location.use_dynamic_menu" class="col-md-6">
                 <display-qr
                    :location="location"
                  />
                </div>
                <div v-if="location.use_dynamic_menu" class="col-md-12">
                  <div class="col-md-6">
                    <image-input
                      :location="location"
                      :label="$t('general.logo')"
                      :image="location.dynamic_menu_logo"
                      imageField="dynamic_menu_logo"
                    />
                  </div>
                  <div class="col-md-6">
                    <image-input
                      :location="location"
                      :label="$t('marketingOffers.banners')"
                      :image="location.dynamic_menu_banner"
                      imageField="dynamic_menu_banner"
                    />
                  </div>
                </div>
              </template>

              <template v-if="location.app_link && location.app_qr">
                <br>
                <div class="col-md-12">
                  <display-qr-app
                    :location="location"
                  />
                </div>
              </template>
            </form>
          </div>
        </div>
      </template>

      <!-- <div class="col-md-12 text-center pad-to-10 pad-bt-10">
        <span v-if="showUpdateWarning" class="help-block warning">{{$t('settingCompany.noTaxMsg')}}</span>
        <button type="submit" @click.prevent="validate" class="btn btn-fill btn-success btn-wd">{{$t('general.update')}}</button>
      </div> -->
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Input} from 'element-ui'
  import swal from 'sweetalert2'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import FileInput from 'src/components/UIComponents/Inputs/FileInput.vue'
  import ImageInput from 'src/components/UIComponents/Inputs/ImageInput.vue'
  import DisplayQr from 'src/components/UIComponents/Inputs/DisplayQr.vue'
  import ImportProductsInput from 'src/components/UIComponents/Inputs/ImportProductsInput.vue'
  import ArchiveInput from 'src/components/UIComponents/Inputs/ArchiveInput.vue'
  import DisplayQrApp from 'src/components/UIComponents/Inputs/DisplayQrApp.vue'
  import 'sweetalert2/dist/sweetalert2.css'
  // import {mapFields} from 'vee-validate'
  Vue.use(Input)

  export default {
    components: {
      [Input.name]: Input,
      PSwitch,
      FileInput,
      ImageInput,
      DisplayQr,
      DisplayQrApp,
      ImportProductsInput,
      ArchiveInput
    },
    props: {
      countries: {},
      modeldata: {},
      taxesData: {},
      tabRefresh: {},
      isLocationGroups: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      isLocationGroups () {
        if (this.isLocationGroups) {
          this.getData()
        }
      },
      countries (value) {
        this.countriesList = value
      },
      modeldata (value) {
        for (var idx in value.locations_details) {
          if (!value.locations_details[idx].vat) {
            value.locations_details[idx].vat = []
          }
          if (!value.locations_details[idx].working_hours) {
            value.locations_details[idx].working_hours = []
          }
          if (!value.locations_details[idx].allow_preorder) {
            value.locations_details[idx].allow_preorder = false
          }
          for (var iDay in this.days) {
            var day = this.days[iDay]
            var index = this.getObjectByElemKeyValue('day', day, value.locations_details[idx].working_hours)
            if (index === false) {
              value.locations_details[idx].working_hours.push({day: day, open_to: '', open_from: '', open: false})
              // value.locations_details[idx].working_hours.push({day: day, open_to: '', open_from: '', open: false, preorder_from: ''})
            } else if (value.locations_details[idx].working_hours[index].open === undefined) {
              // if (value.locations_details[idx].working_hours[index].open_to !== '' &&
              //     value.locations_details[idx].working_hours[index].open_from !== '') {
              //   value.locations_details[idx].working_hours[index].open = true
              // } else {
              //   value.locations_details[idx].working_hours[index].open = false
              // }
              // console.warn(value.locations_details[idx].working_hours[index].preorder_from)
              // if (value.locations_details[idx].working_hours[index].preorder_from === undefined) {
              //   value.locations_details[idx].working_hours[index].preorder_from = ''
              // }
            }
          }
        }
        this.showDelete = value.locations_details.length > 1
        this.model = value
        for (var locIndex in value.locations_details) {
          if (value.locations_details[locIndex].vat) {
            Vue.set(this.model.locations_details[locIndex], 'vat', value.locations_details[locIndex].vat)
          }
        }
      },
      taxesData (value) {
        this.taxes = value.taxes
        this.vat = value.vat
      },
      tabRefresh (value) {
        if (value === this.$t('settingCompany.companyLocations')) {
          this.showUpdateWarning = false
          var data = {
            token: this.$session.get('token')
          }
          var self = this
          var companyID = this.$session.get('selectedCompany')

          this.apiRequest('/settings/general/' + companyID, 'GET', data, function (response) {
            if (response.status === true) {
              self.$emit('updateModelData', response.data[0])
            }
          })
        }
      },
      'model.locations_details': {
        handler: function (newval, oldval) {
          Vue.set(this.model, 'locations_details', newval)
        },
        deep: true
      }
    },
    data () {
      return {
        apiUrl: '',
        model: this.value || this.modeldata,
        countriesList: this.value || this.countries, // this.countries
        sortMethodsList: [],
        states: [],
        taxes: this.value || this.taxesData.taxes,
        vat: this.value || this.taxesData.vat,
        currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
        showDelete: false,
        modelValidate: {
          name: {required: true},
          email: {required: true},
          phone: {required: true},
          number: {required: true},
          street: {required: true},
          city: {required: true},
          state: {required: true},
          country: {required: true},
          working_hours: {required: true},
          email_feedback: {required: true}
        },
        timeFormat: 'HH:mm', // this.getCompanyDetail('time_format'),
        dateFormat: 'DD/MM/YYYY', // this.getCompanyDetail('date_format'),
        pickerNames: ['date_from', 'date_to'],
        days: [
          'monday',
          'tuesday',
          'wednesday',
          'thursday',
          'friday',
          'saturday',
          'sunday'
        ],
        pickerOptions: {
          start: '00:00',
          step: '00:15',
          end: '23:59',
          format: this.timeFormat
        },
        showUpdateWarning: false,
        languages: this.$session.get('defaultData')['available_languages'],
        windowHeight: 0,
        navbarHeaderHeight: 0,
        pageTopHeight: 76,
        loading: true,
        paymentGroups: null,
        deliveryMethods: [],
        menuType: [{'id': 0, 'label': 'PDF'}, {'id': 1, 'label': 'Dynamic'}]
      }
    },
    updated: function () {
    },
    computed: {
    },
    created () {
      this.apiUrl = process.env.API_BASE_URL
    },
    mounted () {
      this.$nextTick(() => {
        this.doHeightCalculation()
        this.loading = false

        window.addEventListener('resize', () => {
          this.doHeightCalculation()
        })
      })
    },
    methods: {
      syncEpRestaurantMenu (location, update = false) {
        this.loading = true
        var data = {
          token: this.$session.get('token'),
          location_id: location.true_id,
          company_id: location.company_id
        }

        if (update) {
          data.update = true
        }

        this.apiRequest('/ep-restaurant/import-menu/' + location.ep_restaurant_id, 'POST', data, (response) => {
          if (response.status) {
            swal({
              text: 'Success',
              type: 'success',
              showCancelButton: false
            })
          } else {
            swal({
              text: 'Error',
              type: 'error',
              showCancelButton: false
            })
          }
          this.loading = false
        })
      },
      syncFreyaCloudMenu (location) {
        this.loading = true
        var data = {
          token: this.$session.get('token'),
          location_id: location.true_id,
          company_id: location.company_id
        }

        this.apiRequest('/freya-cloud/import-products/' + location.freya_cloud_id, 'POST', data, (response) => {
          if (response.status) {
            swal({
              text: 'Success',
              type: 'success',
              showCancelButton: false
            })
          } else {
            swal({
              text: 'Error',
              type: 'error',
              showCancelButton: false
            })
          }
          this.loading = false
        })
      },
      syncGlovoMenu (location) {
        this.loading = true
        var data = {
          token: this.$session.get('token'),
          location_id: location.true_id,
          company_id: location.company_id
        }
        this.apiRequest('/glovo/sync-menu', 'POST', data, (response) => {
          if (response.status) {
            swal({
              text: 'Success',
              type: 'success',
              showCancelButton: false
            })
          } else {
            swal({
              text: response.errorCode ? this.$t('glovo.' + response.errorCode) : 'Error',
              type: 'error',
              showCancelButton: false
            })
          }
          this.loading = false
        })
      },
      importCategories (location) {
        this.$nextTick(function () {
          this.loading = true
        })

        var data = {
          token: this.$session.get('token'),
          location_id: location.true_id,
          company_id: location.company_id
        }

        this.apiRequest('/sync-categories-rkeeper', 'POST', data, (response) => {
          if (response.status === true) {
            swal(
              {
                title: '',
                text: this.$t('rkeeper.importSuccess'),
                type: 'success',
                showConfirmButton: false,
                timer: 1500
              }
            )
            this.$nextTick(() => { this.loading = false })
          } else {
            swal(
              {
                title: '',
                text: this.$t('rkeeper.importError'),
                type: 'error',
                showConfirmButton: false,
                timer: 1500
              }
            )
            this.$nextTick(() => { this.loading = false })
          }
        })
      },
      importProducts (location) {
        this.$nextTick(function () {
          this.loading = true
        })

        var data = {
          token: this.$session.get('token'),
          location_id: location.true_id,
          company_id: location.company_id
        }

        this.apiRequest('/sync-products-rkeeper', 'POST', data, (response) => {
          if (response.status === true) {
            swal(
              {
                title: '',
                text: this.$t('rkeeper.importSuccess'),
                type: 'success',
                showConfirmButton: false,
                timer: 1500
              }
            )
            this.$nextTick(() => { this.loading = false })
          } else {
            swal(
              {
                title: '',
                text: this.$t('rkeeper.importError'),
                type: 'error',
                showConfirmButton: false,
                timer: 1500
              }
            )
            this.$nextTick(() => { this.loading = false })
          }
        })
      },
      syncProductPrices (location) {
        this.$nextTick(function () {
          this.loading = true
        })

        var data = {
          token: this.$session.get('token'),
          location_id: location.true_id,
          company_id: location.company_id
        }

        this.apiRequest('/sync-product-prices-rkeeper', 'POST', data, (response) => {
          if (response.status) {
            swal(
              {
                title: '',
                text: this.$t('rkeeper.syncSuccess'),
                type: 'success',
                showConfirmButton: false,
                timer: 1500
              }
            )
            this.$nextTick(() => { this.loading = false })
          } else {
            swal(
              {
                title: '',
                text: this.$t('rkeeper.syncError'),
                type: 'error',
                showConfirmButton: false,
                timer: 1500
              }
            )
          }
          this.$nextTick(() => { this.loading = false })
        })
      },
      syncOptionPrices (location) {
        this.$nextTick(function () {
          this.loading = true
        })

        var data = {
          token: this.$session.get('token'),
          location_id: location.true_id,
          company_id: location.company_id
        }

        this.apiRequest('/sync-option-prices-rkeeper', 'POST', data, (response) => {
          if (response.status) {
            swal(
              {
                title: '',
                text: this.$t('rkeeper.syncSuccess'),
                type: 'success',
                showConfirmButton: false,
                timer: 1500
              }
            )
            this.$nextTick(() => { this.loading = false })
          } else {
            swal(
              {
                title: '',
                text: this.$t('rkeeper.syncError'),
                type: 'error',
                showConfirmButton: false,
                timer: 1500
              }
            )
          }
          this.$nextTick(() => { this.loading = false })
        })
      },
      updateTazzMenu (location) {
        this.loading = true
        var data = {
          token: this.$session.get('token'),
          location_id: location.true_id,
          company_id: location.company_id
        }
        this.apiRequest('/tazz/update-menu', 'POST', data, (response) => {
          if (response.status) {
            swal({
              text: 'Success',
              type: 'success',
              showCancelButton: false
            })
          } else {
            swal({
              text: response.errorCode ? this.$t('importProductsError.' + response.errorCode) : 'Error',
              type: 'error',
              showCancelButton: false
            })
          }
          this.loading = false
        })
      },
      updateProductPricesMagister (location) {
        this.loading = true
        var data = {
          token: this.$session.get('token'),
          location_id: location.true_id,
          company_id: location.company_id
        }
        this.apiRequest('/magister/sync-products', 'POST', data, (response) => {
          if (response.status) {
            swal({
              text: 'Success',
              type: 'success',
              showCancelButton: false
            })
          } else {
            swal({
              text: 'Error',
              type: 'error',
              showCancelButton: false
            })
          }
          this.loading = false
        })
      },
      updateProductStocksMagister (location) {
        this.loading = true
        var data = {
          token: this.$session.get('token'),
          location_id: location.true_id,
          company_id: location.company_id
        }
        this.apiRequest('/magister/sync-stock', 'POST', data, (response) => {
          if (response.status) {
            swal({
              text: 'Success',
              type: 'success',
              showCancelButton: false
            })
          } else {
            swal({
              text: 'Error',
              type: 'error',
              showCancelButton: false
            })
          }
          this.loading = false
        })
      },
      updateVatPrinterId (obj, locIndex, taxIndex) {
        const selectElement = obj.target
        const selectedOptionName = selectElement.options[selectElement.selectedIndex].getAttribute('data-name')
        // console.log(selectedOptionId)
        this.model.locations_details[locIndex].taxes[taxIndex].name = selectedOptionName
      },
      getData () {
        this.deliveryMethods = this.getCompanyDetail('delivery_options_labels')
        this.timeFormat = this.getCompanyDetail('time_format')
        this.dateFormat = this.getCompanyDetail('date_format')
        this.sortMethodsList = this.$session.get('defaultData').sort_products_methods
        var data = {
          token: this.$session.get('token')
        }
        this.apiRequest('/settings/payment-groups/' + this.$session.get('selectedCompany'), 'GET', data, (response) => {
          if (response.status === true) {
            if (response.data.length === 0) {
              this.paymentGroups = null
            } else {
              this.paymentGroups = response.data
            }
          }
        })
      },
      checkVal (location) {
        // console.warn(location.allow_preorder)
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate (pageId) {
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.saveDetails(false, null)
          } else {
            // console.warn(this.errors)
          }
        })
      },
      doHeightCalculation () {
        this.windowHeight = window.innerHeight
        // this.navbarHeaderHeight = this.$refs.navbarHeader.clientHeight
      },
      showStateDrop (location) {
        var countryIso = location.country
        var countries = this.$session.get('defaultData').countries
        var countryIdx = this.getObjectByElemKeyValue('alpha2', countryIso, countries)

        if (countries[countryIdx] !== undefined && countries[countryIdx].states.length) {
          // location.states = countries[countryIdx].states
          return true
        } else {
          return false
        }
      },
      getStatesOptions (location) {
        var countryIso = location.country
        var countries = this.$session.get('defaultData').countries
        var countryIdx = this.getObjectByElemKeyValue('alpha2', countryIso, countries)

        if (countries[countryIdx] !== undefined && countries[countryIdx].states.length) {
          return countries[countryIdx].states
        } else {
          return []
        }
      },
      updateCountry (location) {
        location.state = null
        location.state_id = null
      },
      disableTaxOption (locId, taxId) {
        let locIdx = this.getObjectByElemKeyValue('id', locId, this.model.locations_details)
        let thisTaxIdx = this.getObjectByElemKeyValue('id', taxId, this.model.locations_details[locIdx]['taxes'])

        if (thisTaxIdx !== false) {
          return true
        } else {
          return false
        }
      },
      disableVatOption (locIdx, taxId) {
        // let locIdx = this.getObjectByElemKeyValue('id', locId, this.model.locations_details)
        let thisTaxIdx = this.getObjectByElemKeyValue('tax_id', taxId, this.model.locations_details[locIdx]['vat'])

        if (thisTaxIdx !== false) {
          return true
        } else {
          return false
        }
      },
      addLocation () {
        var data = {
          'token': this.$session.get('token'),
          'type': 'hashes'
        }
        var self = this
        this.apiRequest('/helpers', 'GET', data, function (response) {
          if (response.status === true) {
            let newRow = {
              id: null,
              city: '',
              country: '',
              email: null,
              name: null,
              taxes: [],
              image: null,
              use_dynamic_menu: 1,
              ordering_management: [
                {
                  type: 'pick_up',
                  label: 'Pick-up',
                  enabled: false,
                  available_days: [],
                  default_waiting_time: null,
                  payment_options: {cash: false, credit_card: false, pos: false},
                  delivery_hour_usage: 0,
                  hour_and_date_delivery_hour_usage: 1
                },
                {
                  type: 'meet_half',
                  label: 'Meet me half way',
                  enabled: false,
                  available_days: [],
                  default_waiting_time: null,
                  payment_options: {cash: false, credit_card: false, pos: false},
                  locations: [],
                  delivery_hour_usage: 0,
                  hour_and_date_delivery_hour_usage: 1
                },
                {
                  type: 'delivery',
                  label: 'Delivery',
                  enabled: false,
                  available_days: [],
                  default_waiting_time: null,
                  payment_options: {cash: false, credit_card: false, pos: false},
                  cost: null,
                  shipping_cost: [],
                  delivery_hour_usage: 0,
                  hour_and_date_delivery_hour_usage: 1
                },
                {
                  type: 'eat_location',
                  label: 'Eat on location',
                  enabled: false,
                  available_days: [],
                  default_waiting_time: null,
                  payment_options: {cash: false, credit_card: false, pos: false},
                  delivery_hour_usage: 0,
                  hour_and_date_delivery_hour_usage: 1
                },
                {
                  type: 'self_ordering',
                  label: 'Self Ordering',
                  enabled: false,
                  available_days: [],
                  default_waiting_time: null,
                  max_distance_in_meter: 50,
                  payment_options: {cash: false, credit_card: false, pos: false},
                  delivery_hour_usage: 0,
                  hour_and_date_delivery_hour_usage: 1
                }
              ],
              phone: null,
              street: null,
              number: null,
              working_hours: []
              // allow_preorder: false
            }
            // newRow = self.newLocation
            newRow.id = response.data[0].id

            newRow.isNew = true

            for (let iDay in self.days) {
              // newRow.working_hours.push({day: self.days[iDay], open_to: '', open_from: '', open: false, preorder_from: ''})
              newRow.working_hours.push({day: self.days[iDay], open_to: '22:00', open_from: '10:00', open: false})
            }

            for (let iOrder in newRow.ordering_management) {
              for (let iDay in self.days) {
                newRow.ordering_management[iOrder].available_days.push({day: self.days[iDay], open_to: '22:00', open_from: '10:00', open: false})
              }
            }
            self.model.locations_details.unshift(newRow)
          } else {
            swal({'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
          }
        })
      },
      scrollToPx (px) {
        // console.warn(px)
        var elem = this.$el
        // console.warn(elem.clientHeight)
        elem.scrollTop = elem.clientHeight
        elem.scrollIntoView({
          alignTop: true,
          behavior: 'smooth'
        })
      },
      deleteLocation (id) {
        var btnCounter = 3
        var self = this
        var companyID = this.$session.get('selectedCompany')

        var data = {
          token: this.$session.get('token'),
          company_id: companyID,
          location_id: id
        }

        this.apiRequest('/settings/can-delete-location', 'POST', data, function (response) {
          if (response.status === true) {
            // location ca be deleted
            swal({
              text: self.$t('settingCompany.areYouSureDelete'),
              type: 'question',
              showCancelButton: true,
              confirmButtonText: 'Yes (' + btnCounter + ')'
            })
            .then((result) => {
              if (result) {
                var locIdx = self.getObjectByElemKeyValue('id', id, self.model.locations_details)
                if (locIdx) {
                  // delete this.model.locations_details[locIdx]
                  self.model.locations_details.splice(locIdx, 1)
                }
                if (!self.model.from_json) {
                  self.apiRequest('/delete-location', 'POST', data, function (response) {
                    if (response.status === true) {
                      self.saveDetails(true, id)
                    }
                  })
                } else {
                  self.saveDetails(true, id)
                }
              }
            })
            swal.disableConfirmButton()

            var btnInterval = setInterval(function () {
              btnCounter--

              if (btnCounter >= 1) {
                swal.getConfirmButton().textContent = 'Yes (' + btnCounter + ')'
              } else {
                swal.getConfirmButton().textContent = 'Yes'
                clearInterval(btnInterval)
                swal.enableConfirmButton()
              }
            }, 1000)
          } else if (response.status === false && response.errors.location_ids !== undefined) {
            swal({'text': self.$t('settingCompany.deleteLocationValidation'), 'type': 'error'}).catch(() => {})
          } else {
            swal({'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
          }
        })
      },
      copyProducts (id) {
        let self = this
        let copyFrom = this.$refs['copyFrom' + id][0].value
        var data = {
          copy_to: id,
          copy_from: copyFrom,
          token: self.$session.get('token')
        }
        self.apiRequest('/locations/duplicate-products', 'POST', data, function (response) {
          if (response.status === true) {
            swal({'text': self.$t('settingCompany.companyProdCopied'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
          } else {
            swal({'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
          }
        })
      },
      deleteProducts (id) {
        let self = this
        var data = {
          location: id,
          token: self.$session.get('token')
        }
        swal({
          text: self.$t('settingCompany.areYouSureDeleteProd'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        })
        .then((result) => {
          if (result) {
            self.apiRequest('/locations/delete-products', 'POST', data, (response) => {
              if (response.status === true) {
                swal({'text': self.$t('settingCompany.companyProdDeleted'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
              } else {
                swal({'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
              }
            })
          }
        })
      },
      addNewTax (locId) {
        let newRow = {
          'id': null,
          'type': null,
          'amount': null
        }
        var locIdx = this.getObjectByElemKeyValue('id', locId, this.model.locations_details)
        if (locIdx) {
          if (this.model.locations_details[locIdx]['taxes'] === undefined) {
            this.model.locations_details[locIdx].push({'taxes': []})
          }
          this.model.locations_details[locIdx]['taxes'].push(newRow)
          this.showUpdateWarning = true
        }
      },
      addNewVat (locIdx, locToken) {
        let newRow = {
          'id': null,
          'company_id': this.$session.get('selectedCompany'),
          'location_token': locToken,
          'tax_id': null,
          'type': 'PERCENTAGE_EXCLUDED',
          'amount': null,
          'printer_id': null,
          'is_vat': true
        }
        let copy = []
        if (this.model.locations_details[locIdx]['vat'] && this.model.locations_details[locIdx]['vat'].length) {
          copy = [...this.model.locations_details[locIdx]['vat']]
        }
        copy.push(newRow)
        Vue.set(this.model.locations_details[locIdx], 'vat', copy)
        this.showUpdateWarning = true
      },
      deleteTax (locId, taxId) {
        var self = this
        swal({
          text: self.$t('settingCompany.areYouSureTax'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        })
        .then((result) => {
          if (result) {
            let locIdx = this.getObjectByElemKeyValue('id', locId, this.model.locations_details)
            let thisTaxIdx = this.getObjectByElemKeyValue('id', taxId, this.model.locations_details[locIdx]['taxes'])
            this.model.locations_details[locIdx]['taxes'].splice(thisTaxIdx, 1)
            this.showUpdateWarning = true
            // swal({'text': 'Tax deleted successfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000})
          }
        })
        .catch({})
      },
      deleteVat (locIdx, taxId, vatIndex) {
        if (!taxId) {
          this.model.locations_details[locIdx]['vat'].splice(vatIndex, 1)
          return
        }
        var self = this
        swal({
          text: self.$t('settingCompany.areYouSureVat'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        })
        .then((result) => {
          if (result) {
            var data = {
              'token': this.$session.get('token')
            }
            this.apiRequest('/location/vat/delete/' + taxId, 'DELETE', data, (response) => {
              if (response.status) {
                this.model.locations_details[locIdx]['vat'].splice(vatIndex, 1)
                swal({'text': this.$t('vat.deleteVatSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000})
              } else {
                swal({'text': this.$t('vat.deleteVatError'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000})
              }
            })
            this.showUpdateWarning = true
              // swal({'text': 'Tax deleted successfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000})
          }
        })
        .catch({})
      },
      saveDetails (isDel, locId) {
        this.$nextTick(function () { this.loading = true })
        var companyID = this.$session.get('selectedCompany')
        var countries = this.$session.get('defaultData').countries
        var currentLocations = []
        for (var locIdx in this.model.locations_details) {
          var locData = this.copyObject(this.model.locations_details[locIdx])
          let countryIso = locData.country
          let countryIdx = this.getObjectByElemKeyValue('alpha2', countryIso, countries)
          let states = []

          if (countries[countryIdx] !== undefined && countries[countryIdx].states.length) {
            states = countries[countryIdx].states
          }

          if (states.length && locData.state_id) {
            var state = this.getObjectByElemKeyValue('id', locData.state_id, states)
            if (state !== undefined) {
              locData.state = states[state].name
            } else {
              locData.state = ''
            }
          }
          delete locData.states
          currentLocations[locIdx] = locData
        }
        if (this.model.tips_taxes === null) {
          this.model.tips_taxes = []
        }
        var data = {
          'token': this.$session.get('token'),
          'locations_details': JSON.stringify(currentLocations)
        }

        var self = this
        this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
          if (response.status === true) {
            self.$emit('updateModelData', response.data[0])
            self.$session.set('companyName', response.data[0].name)
            self.errors.clear()
            self.$nextTick(function () {
              self.loading = false
              self.syncCompanySessionAndCache(response.data[0])
            })
            swal({'text': self.$t('settingCompany.companyUpdated'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
            if (isDel) {
              // locId
              let filterCookie = self.$cookie.get('filter-locations')
              if (filterCookie) {
                filterCookie = JSON.parse(filterCookie)
                let indexOf = filterCookie.indexOf(locId)
                if (indexOf !== -1) {
                  filterCookie.splice(indexOf, 1)
                  self.$cookie.set('filter-locations', JSON.stringify(filterCookie), 30)
                }
              }
            }
            self.$emit('companyName', response.data[0].name)
            self.showDelete = self.model.locations_details.length > 1
          } else {
            self.$nextTick(function () { self.loading = false })
            if (response.errors.latlng !== undefined) {
              swal({'text': self.$t('settingCompany.wrongAddress', {location: response.errors.latlng}), 'type': 'error', 'showConfirmButton': true}).catch(() => {})
            } else {
              swal({'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
            }
          }
        })
      },
      goToCompany () {
        this.$emit('setSelectedTab', this.$t('settingsPages.taxLabeling'))
      },
      handleMenu (index, event) {
        this.model.locations_details[index].use_dynamic_menu = event.target.value
      },
      downloadForm () {
        let data = {
          token: this.$session.get('token')
        }
        this.apiRequest('/download-import-form', 'GET', data, (response) => {
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/Tabs/CompanyLocations.vue